import * as React from "react"

const MOBILE_BREAKPOINT = 768

/**
 * Detecta se o viewport atual é mobile (< 768px).
 *
 * Usa lazy initializer no `useState` pra resolver o valor **síncronamente**
 * antes do primeiro render — evita flash de hydration (componentes pintando
 * desktop e depois "saltando" pra mobile em <16ms). Em CSR puro (este projeto)
 * o valor sai certo já no primeiro paint.
 *
 * Em SSR `window` é undefined → retorna `false` no servidor e atualiza no
 * cliente via efeito; isso é flash de SSR mas o projeto é CSR-only.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() =>
    typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
